export default function Engagement() {
  return (
    <>
      <div className='card rounded-0 w-100 '>
        <div className='min-h-100'>
          <iframe
            title='Promo'
            src={`https://docs.dejavooextra.com/`}
            width='100%'
            className='h-100'
            allow='payment'
          ></iframe>
        </div>
      </div>
    </>
  )
}
